module.exports = __webpack_public_path__ + "static/media/branding_s24px.3ec228d3.svg";